<nz-form-item>
  <nz-form-label [nzRequired]="to.required || (!to.required && to['fileName'])">
    {{ to.label }}
  </nz-form-label>
  <nz-form-control [nzErrorTip]="errorTpl" [nzValidateStatus]="errorState">
    <div
      [ngClass]="{
        'custom-select-file': true,
        error: showError,
        disabled: to.disabled,
      }"
    >
      <nz-upload
        class="wrapper-upload"
        [nzAccept]="to['fileType']"
        [(nzFileList)]="fileList"
        [nzBeforeUpload]="beforeUpload"
        [nzRemove]="handleRemove"
        [nzShowUploadList]="showUploadList"
        [nzDisabled]="to.disabled"
      >
        <button
          nz-button
          type="button"
          nzType="primary"
          [class]="to.disabled ? 'btn-disabled' : ''"
        >
          {{ "BUTTON.SELECT" | translate }}
        </button>
      </nz-upload>
      <span *ngIf="fileList.length === 0" class="placeholder">{{
        to.placeholder
      }}</span>
    </div>
    <p
      style="font-size: 16px; margin: 4px 0 0"
      *ngIf="to['showRecords'] && fileList.length"
    >
      <ng-container *ngIf="!to.disabled; else enabled">
        取込データ件数：<span style="color: #ff7875">{{ totalRecord }}件</span>
      </ng-container>
      <ng-template #enabled>
        <span style="color: rgba(0, 0, 0, 0.25)">
          取込データ件数：<span style="color: rgba(255, 119, 117, 0.5)"
            >{{ totalRecord }}件</span
          >
        </span>
      </ng-template>
    </p>
    <ng-template #errorTpl let-control>
      <formly-validation-message [field]="field"></formly-validation-message>
    </ng-template>
  </nz-form-control>
</nz-form-item>
